import { ChartData, ChartOptions, ChartType } from "chart.js";

export class ChartJsDirectiveController {
  static $inject = [];

  type!: ChartType;
  options!: ChartOptions;
  chartData!: ChartData;

  constructor() {}
}
